module.exports = __webpack_public_path__ + "img/terminar_chamada.31fbe4cd.gif";